import { Link, Stack } from 'shared';
import React from 'react';

export const GlobalFooter: React.FC = () => {
  return (
    <Stack
      gap={20}
      direction="horizontal"
      style={{ justifyContent: 'center', alignItems: 'center' }}
    >
      <p style={{ margin: 0 }}>Copyright Sentry {new Date().getFullYear()}</p>
      <span>|</span>
      <Link to="/terms-conditions">Terms and Conditions</Link>
    </Stack>
  );
};
